class VirtualDirector {
  constructor(playerWrapperElement, playerVideoElement, options = {
    scene_w: 5572,
    scene_h: 2040,
    center_top: 522,
    center_bottom: 1640,
    top_inset: 290,
    fps: 30,
    min_zoom: 100,
    max_zoom: 250
  }, timeline = []) {
    this.isPlaying = false;
    this.canPlay = false;
    this.playerWrapperElement = playerWrapperElement;
    this.playerVideoElement = playerVideoElement;
    this.duration = playerVideoElement.duration;
    this.options = options;
    this.timeline = timeline;
    this.mode = "vd";

    //For excerpted HLS clips
    this.excerptOffset = 0;

    var that = this;

    this.playerVideoElement.onloadedmetadata = function() {
      that.duration = that.playerVideoElement.duration;
      that.canPlay = true;
      if (that.isPlaying) {
        that.player();
      }
    }
  }
  play() {
    this.isPlaying = true;
    this.player();
  }
  pause() {
    this.isPlaying = false;
  }
  player() {
    if (this.isPlaying && this.canPlay) {
      var that = this;
      this.step();
    }
  }
  step() {
    var offsetMS = this.getOffsetMS();
    var ptz = this.ptzFromTimeline(this.timeline, offsetMS / this.options.fps);
    if (offsetMS < this.duration * 1000 && this.isPlaying) {
      this.updatePosition(ptz.pan, ptz.tilt, ptz.zoom);
      window.requestAnimationFrame(this.step.bind(this));
    }
  }
  stepOnce() {
    var offsetMS = this.getOffsetMS();
    var ptz = this.ptzFromTimeline(this.timeline, offsetMS / this.options.fps);
    this.updatePosition(ptz.pan, ptz.tilt, ptz.zoom);
  }
  getOffsetMS() {
    return (this.playerVideoElement.currentTime * 1000) + this.excerptOffset;
  }
  getFOV(scene_width, scene_height, pinch_top, pinch_bottom, top_in, pan, tilt, zoom, player_width, player_height) {
    // Generates a crop window (video window) out of the full scene based on requested Pan/Tilt/Zoom.
    // Returns both absolute and relative top/left offsets, height/width and scale factor.
    //
    // Accepted parameters:
    //   scene_width: full scene (butterfly) width in px
    //   scene_height: full scene (butterfly) height in px
    //   pinch_top: the top boundary of center perspective pinch in px
    //   pinch_bottom: the bottom boundary of center perspective pinch in px
    //   top_in: the laterla (left/right) horizontal inset of perspective pinch
    //   requested_pan: the pan input from the user interaction (-1.0...1.0)
    //   requested_tilt: the tilt input from the user interaction (-1.0...1.0)
    //   base_zoom: the current base zoom requested by user (100...250)
    //   zoom_power: the extra zoom level to apply during navigation (0...1.0). The higher the value, the stronger the "push" to the corner
    //   player_width: the requested output frame (video window) horizontal size in px
    //   player_height: the requested output frame (video window) vertical size in px

    var aspect_ratio = player_width / player_height;

    var scene_center_x = scene_width / 2;
    var scene_center_y = pinch_top + (pinch_bottom - pinch_top) / 2;

    var fov_height = (pinch_bottom - pinch_top) * 100 / zoom;
    var fov_width = fov_height * aspect_ratio;
    var fov_half_width = fov_width / 2;
    var fov_half_height = fov_height / 2;

    var max_pan_x_offset = (scene_width - fov_width) / 2 - top_in * 1.15 + (top_in * (this.options.scene_h - fov_height) / this.options.scene_h * ((tilt + 1) / 2));
    var fov_center_x = scene_center_x + max_pan_x_offset * pan;

    var fov_center_y;
    if (fov_height >= pinch_bottom - pinch_top && Math.abs(scene_center_x - fov_center_x) <= fov_half_width)
      fov_center_y = scene_center_y;
    else {
      var min_tilt_y_offset = scene_center_y - fov_half_height - pinch_top;
      var max_tilt_y_offset = pinch_bottom - (scene_center_y + fov_half_height);

      if (Math.abs(scene_center_x - fov_center_x) > fov_half_width) {
        min_tilt_y_offset += ((Math.abs(scene_center_x - fov_center_x) - fov_half_width) * pinch_top / (this.options.scene_w / 2 - top_in));
        max_tilt_y_offset += ((Math.abs(scene_center_x - fov_center_x) - fov_half_width) * (scene_height - pinch_bottom) / (this.options.scene_w / 1.85 - top_in));
      }

      if (tilt < 0)
        fov_center_y = scene_center_y + min_tilt_y_offset * tilt;
      else
        fov_center_y = scene_center_y + max_tilt_y_offset * tilt;
    }

    var l = fov_center_x - fov_half_width;
    var w = fov_width;
    var t = fov_center_y - fov_half_height;
    var h = fov_height;

    return ({
      pan: pan,
      tilt: tilt,
      zoom: zoom,
      left: l.toFixed(0),
      top: t.toFixed(0),
      width: w.toFixed(0),
      height: h.toFixed(0),
      left_pct: (l / scene_width).toFixed(4),
      top_pct: (t / scene_height).toFixed(4),
      width_pct: (w / scene_width).toFixed(4),
      height_pct: (h / scene_height).toFixed(4)
    });
  }
  getFOVAutozoom(scene_width, scene_height, pinch_top, pinch_bottom, top_in, requested_pan, requested_tilt, base_zoom, zoom_power, player_width, player_height) {
    // Generates a UX-oriented Pan/Tilt/Zoom position.
    // Takes pan and tilt as percentage of the full sceeen navigation and applies auto-zoom
    // to allow user to push towards the corners of the scene
    // Returns both absolute and relative top/left offsets, height/width and scale factor.
    //
    // Accepted parameters:
    //   scene_width: full scene (butterfly) width in px
    //   scene_height: full scene (butterfly) height in px
    //   pinch_top: the top boundary of center perspective pinch in px
    //   pinch_bottom: the bottom boundary of center perspective pinch in px
    //   top_in: the laterla (left/right) horizontal inset of perspective pinch
    //   requested_pan: the pan input from the user interaction (-1.0...1.0)
    //   requested_tilt: the tilt input from the user interaction (-1.0...1.0)
    //   base_zoom: the current base zoom requested by user (100...250)
    //   zoom_power: the extra zoom level to apply during navigation (0...1.0). The higher the value, the stronger the "push" to the corner
    //   player_width: the requested output frame (video window) horizontal size in px
    //   player_height: the requested output frame (video window) vertical size in px

    var pan = requested_pan;
    var tilt = requested_tilt;
    var zoom = base_zoom;

    if (base_zoom < this.options.max_zoom) {
      var zoom_pan = base_zoom + Math.abs(pan) * Math.abs(pan) * (this.options.max_zoom - base_zoom) * zoom_power;
      var zoom_tilt = base_zoom + Math.abs(pan) * Math.abs(tilt) * (this.options.max_zoom - base_zoom) * zoom_power;
      zoom = zoom_pan > zoom_tilt ? zoom_pan : zoom_tilt;
    }
    return this.getFOV(
      scene_width,
      scene_height,
      pinch_top,
      pinch_bottom,
      top_in,
      requested_pan,
      requested_tilt,
      zoom,
      player_width,
      player_height);

  }
  updatePosition(pan, tilt, zoom) {
    // Updates the transforms on both player window and position preview window
    // If no parameters

    if (!pan && !tilt && !zoom) {
      pan = 0;
      tilt = 0;
      zoom = 150;
    }

    let elWidth =  this.playerWrapperElement.offsetWidth;
    let elHeight =  this.playerWrapperElement.offsetHeight;

    if (this.mode == "vd") {
      var FoV = this.getFOV(
        this.options.scene_w, this.options.scene_h, this.options.center_top, this.options.center_bottom, this.options.top_inset, pan, tilt, zoom, elWidth, elHeight
      );
    } else if (this.mode == "user") {
      var FoV = this.getFOVAutozoom(
        this.options.scene_w, this.options.scene_h, this.options.center_top, this.options.center_bottom, this.options.top_inset, pan, tilt, zoom, 0.5, elWidth, elHeight
      );
    }

    if (FoV) {
      let left = -FoV.left / (FoV.width / elWidth);
      let top = -FoV.top / (FoV.height / elHeight);
      let transform = "translate("+ left + "px" + ", " + top + "px)";

      // Position the player
      this.playerVideoElement.style.width = this.options.scene_w / (FoV.width / elWidth) + "px";
      this.playerVideoElement.style.height = this.options.scene_h / (FoV.height / elHeight) + "px";
      this.playerVideoElement.style.transform = transform;
    }

  }
  ptzFromTimeline(timeline, frame_idx) {
    // Generates Pan/Tilt/Zoom from a VD timeline and a frame index
    // Frame index is 0-based and is calculated as time offset / fps
    // Partial frames supported for inter-frame calculations

    //timeline -> each array is: start frame, duration, pan, tilt, zoom

    var pan = 0 // #-1...1
    var tilt = 0 // #-1...1
    var zoom = 100 // #100...250

    if (frame_idx < 0 || this.timeline == null || this.timeline.length < 1) return null;

    var prev_end = this.timeline[0][0] + this.timeline[0][1];
    var prev_pan = this.timeline[0][2];
    var prev_tilt = this.timeline[0][3];
    var prev_zoom = this.timeline[0][4];
    var fv = null;

    for (fv in this.timeline) {
      var fov = this.timeline[fv];
      if (frame_idx >= fov[0] && frame_idx < fov[0] + fov[1]) {
        pan = fov[2]
        tilt = fov[3]
        zoom = fov[4]
        break;
      } else if (frame_idx < fov[0]) {
        // how far inbetween are we ?
        var offset = (frame_idx - prev_end) / (fov[0] - prev_end)
        //#TODO: we might want to add easing here!
        pan = prev_pan + (fov[2] - prev_pan) * offset
        tilt = prev_tilt + (fov[3] - prev_tilt) * offset
        zoom = prev_zoom + (fov[4] - prev_zoom) * offset
        break;
      } else {
        pan = fov[2]
        tilt = fov[3]
        zoom = fov[4]
      }

      prev_end = fov[0] + fov[1];
      prev_pan = fov[2];
      prev_tilt = fov[3];
      prev_zoom = fov[4];
    }

    return {
      pan: pan,
      tilt: tilt,
      zoom: zoom
    }

  }
}

export default VirtualDirector
